export const nonNegative = number => {
  if (isNaN(number)) {
    return 0
  }

  return Math.max(0, number)
}
